export const COMPANY_ID = '5dea62d620e91a13c99c0075'; //

export const ARRAY_GUESTS_TEXT = [" гость", ' гостя', ' гостей'];
export const ARRAY_HOURS_TEXT = [" час", ' часа', ' часов'];

export const dateFormat = {
    full: "YYYY-MM-DDTHH:mm:ss",
    short: "YYYY-MM-DD"
};
